import { createContext } from 'react';

import type { SortingContextStore } from './sorting-context.store';

export const SortingContext = createContext<SortingContextStore<any, any>>(null!);
